import clsx from 'clsx';
import React from 'react';
import styles from './tab-item.module.scss';

export interface ITabItem {
	id: string;
	label: string;
}

interface ITabItemProps {
	tabItem: ITabItem;
	onChange: (tabItem: ITabItem) => void;
	selectedTabItem?: ITabItem;
}

export const TabItem = (props: ITabItemProps): React.JSX.Element => {
	const isSelected = props.selectedTabItem?.id === props.tabItem.id;

	const handleClick = (): void => {
		props.onChange(props.tabItem);
	};

	return (
		<li className={clsx(isSelected ? styles.tabItemActive : styles.tabItem)}>
			<button type="button" onClick={handleClick} role="tab" aria-selected={isSelected}>
				<span>{props.tabItem.label}</span>
			</button>
		</li>
	);
};
